var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mode != 'hidden')?_c('v-card',[_c('v-select',{attrs:{"items":_vm.themes,"label":"Theme","dense":""},on:{"change":_vm.changeTheme},model:{value:(_vm.selectTheme),callback:function ($$v) {_vm.selectTheme=$$v},expression:"selectTheme"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }